import api from "@/services/api"
import type { Tenant } from "./sharedTypes/tenants"

type PairDeviceBody = {
  serialNumber: string
  deviceSecret: string
  merchantId: string
  appVersion: string
  model?: string | undefined
  platform?: string | undefined
  operatingSystem?: string | undefined
  webViewVersion?: string | undefined
}

export type PairDeviceResponse =
  | {
      accessToken: string
      onboardingComplete: true
      tenantState: Tenant
    }
  | {
      accessToken: string
      onboardingComplete: false
      tenantState: { name: "merchant" }
    }

export const pairDevice = async (
  payload: PairDeviceBody
): Promise<PairDeviceResponse> => {
  const { body } = await api.post<PairDeviceResponse>(
    "/auth/pair-device/",
    { body: payload, version: 3, timeoutMs: 15000 }
  )

  return body
}
